import { createDrawOrder, createOrder } from '@/api/account';
import { accountInfo } from '@/api/v4';
import router from "@/router";
import store from '@/store';
import message from '@/utils/message';
import { getFbRechargeRecords, updateFbRechargeRecords } from '@/api/user';
import { KwaiqEvent } from '@/utils/KwaiqEvent';
import { CHANNEL_CONFIG, LOCAL_STORE, ORDER_TYPE, SESSION_STORE, USER_TYPE } from '@/config/constConfig';
import { currentCashbackLimit, currentChannel } from '@/config/config';
import { getSessionData, setSessionData } from './sessionHandle';
import { showAlert } from '@/utils/function';
import { i18n } from '@/i18n/config';
import { changeAmount, getGold } from '@/utils/currencyUtils';
import { nextTick } from 'vue';
import { AdJustAndroidEvent } from '@/utils/AdJustAndroidEvent';


let w: any = window;

const VEST_LINKS = w.VEST_LINKS;

/**
 * 获取账户最新余额
 * @param [isfromGame=false] 是否从游戏退出
*/
export function freshBalance(isfromGame: boolean = false, callBack?: Function) {
    accountInfo({}).then((res: any) => {
        if (res.data.success) {
            let result = res.data.data;
            store.state.accountInfo.gold = result.accountGold;
            store.state.accountInfo.vipLevel = result.vipLevel;
            store.state.accountInfo.rebateLevel = result.rebateLevel;
            store.state.accountInfo.vipUpgradeRewardAmount = result.vipUpgradeRewardAmount;
            store.state.accountInfo.returnAmount = result.returnAmount;
            store.state.accountInfo.withdrawNum = result.withdrawNum;
            store.state.accountInfo.extensionCode = result.extensionCode;
            setSessionData(SESSION_STORE.ACCOUNT_INFO.key, result);

            // let link = getBaseUrl() + "?code=" + result.extensionCode;
            // localStorage.setItem(LOCAL_STORE.SHARE_LINK, link);

            checkShowLevel();
            getRechargeReports();
            console.log("isfromGame:", isfromGame);
            isfromGame?checkAmountLimit():'';

            callBack && callBack();
        } else if (res.data.msgCode == "token_invalid") {
            let isDsibale = localStorage.getItem(LOCAL_STORE.IS_DISBALE);
            if (isDsibale != "1") {
                localStorage.setItem(LOCAL_STORE.IS_DISBALE, "1");
            } else {
                store.state.isUserDisbale = true;
            }
        }
    });
}

/**充值 */
export function toCharge(orderInfo: any) {
    sendChargeApi(createChargeOrderInfo(orderInfo));
}

/**提现 */
export async function toWithdraw(amount: number): Promise<any> {
    return new Promise((resolve, reject) => {
        let order = createWithdrawOrderInfo(amount);
        createDrawOrder(order).then((res: any) => {
            if (!res.data.success) {
                resolve(res.data);
            } else {
                if (store.state.userType == USER_TYPE.B) {
                    resolve(res.data);
                } else {
                    router.push({path: '/history', query: {jumpType: 2}});
                }
                return ;
            }
        });
    });
}

/**获取记录上报事件 并通知接口已上报*/
function getRechargeReports() {
    getFbRechargeRecords({}).then((res: any) => {
        if (res.data.success) {
          let fbRechargeRecords = res.data.data.fbRechargeRecords;
          let orderIds = [];
          if (fbRechargeRecords.length > 0) {
            for (let item of fbRechargeRecords) {
                let tempAmount = changeAmount(item.amount);
                let orderId = item.orderId;
                if (item.isFirstRecharge == 1) {
                    KwaiqEvent.EventFirstCharge(tempAmount);
                    AdJustAndroidEvent.firstRecharge(tempAmount);
                }
                if (item.isFbAvailable == 1) {
                    //FbEvent.EventDoCharge(tempAmount, orderId);
                }
                KwaiqEvent.EventDoCharge(tempAmount);
                AdJustAndroidEvent.Rechargesuccess(tempAmount);
                AdJustAndroidEvent.Totalpurchase(tempAmount);
                orderIds.push(orderId);
            }
            orderIds.length > 0 &&
              updateFbRechargeRecords({
                reportStatus: 1,
                errorCode: "",
                enableFlag: 1,
                orderIds: orderIds,
              }).then((res) => {});
          }
        } else {
          
        }
    });
}

/**发送充值订单请求 */
function sendChargeApi(orderInfo: any) {
    createOrder(orderInfo).then((res: any)=> {
        if (res.data.success == false) {
            return message({ text: res.data.msg });
        } else {
            let url = res.data.data.payUrl;
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            // isiOS ? (window.location.href = url) : window.open(url);
            if (process.env.VUE_APP_ISAPP == "true") {
                window.location.href = url;
            } else {
                let tempWidowUrl = window.location.href;
                for (let key in VEST_LINKS) {
                    if (tempWidowUrl.indexOf(key) != -1) {
                        let tempUrl = url.split("://");
                        window.location.href = 'openbrowser://' + tempUrl[1];
                        console.log("window.location.href:", window.location.href);
                        return ;
                    }
                }
                window.open(url);
            }
            router.push("/");
            KwaiqEvent.EventDoAddToCart(orderInfo.gold);
        }
    });
}

/**创建充值订单信息 */
function createChargeOrderInfo(orderInfo: any) {
    let tempOrder: any = {};
    if (orderInfo.channelId && orderInfo.id) {
        tempOrder = {
            channelId: orderInfo.channelId,
            itemId: orderInfo.id,
        }
    }
    tempOrder.amount = orderInfo.gold;
    tempOrder.chargeEvent = orderInfo.chargeEvent;  //区别是否是是流程内充值,流程内充值是不加余额的
    if (currentChannel.channel==CHANNEL_CONFIG.ID) {
        tempOrder.payType = orderInfo.payType;
        tempOrder.payTypeCode = orderInfo.payTypeCode;
    }
    return tempOrder;
}

/**创建提现订单信息 */
function createWithdrawOrderInfo(amount: number) {
    let accountInfo: any = localStorage.getItem(LOCAL_STORE.ACCOUNT_INFO);
    if (accountInfo) {
        accountInfo = JSON.parse(accountInfo);
        let params = {
            userName: accountInfo.username,
            accountNumber: currentChannel.channel==CHANNEL_CONFIG.BR?accountInfo.cpf:accountInfo.account,
            phone: currentChannel.channel==CHANNEL_CONFIG.BR ? (accountInfo.type==ORDER_TYPE.PHONE?accountInfo.account:"") : accountInfo.phone,
            email: accountInfo.type==ORDER_TYPE.EMAIL?accountInfo.account:"",
            payType: accountInfo.type,
            amount: amount,
            bankName: accountInfo.id,
            branchBankName: accountInfo.bankName,
            ifsCode: accountInfo.ifscode,
        }
        return params;
    }
    return "";
}


/**检查是否显示vip升级提示 */
function checkShowLevel() {
    let vipLevel = localStorage.getItem(LOCAL_STORE.VIP_LEVEL);
    if (!vipLevel) {
        localStorage.setItem(LOCAL_STORE.VIP_LEVEL, "0");
    }
    
    let showType: number = 0;
    if (store.state.accountInfo.vipLevel > Number(vipLevel)) {
        showType = 1;
        showAlert(true, {
            title: 'common.1',
            msg: i18n.global.t('prop.6', { vipLevel: store.state.accountInfo.vipLevel, amount: getGold(store.state.accountInfo.vipUpgradeRewardAmount) }),
            btnType: 2,
            isShowClose: false,
            confirmCall: () => {
                checkShowLevel();
            }
        });
        localStorage.setItem(LOCAL_STORE.VIP_LEVEL, ""+store.state.accountInfo.vipLevel);
    }
    if (showType == 0) {
        showType = checkShowCashBackTip() ? 2 : showType;
    }
    if (showType == 0) {
        showType = checkShowWithdrawTip() ? 3 : showType;
    }
    if (showType == 0) {
        checkAmountLimit();
    }
}

/**检查是否显示返现提示 */
export function checkShowCashBackTip() {
    let bool = false;
    let cashLevel = localStorage.getItem(LOCAL_STORE.CASHBACK_LEVEL);
    if (!cashLevel) {
        localStorage.setItem(LOCAL_STORE.CASHBACK_LEVEL, "0");
    }
    if (store.state.accountInfo.rebateLevel == 0) {
        return bool;
    }
    if (store.state.accountInfo.rebateLevel > Number(cashLevel)) {
        bool = true;
        nextTick(() => {
            showAlert(true, {
                msg: i18n.global.t('prop.4', { amount: getGold(store.state.accountInfo.returnAmount) }),
                btnType: 2,
                isShowClose: true,
                confirmText: i18n.global.t('prop.5'),
                confirmCall: () => {
                    router.push('/cashBack');
                },
                cancelCall: () => {
                    checkShowLevel();
                }
            });
        })
        localStorage.setItem(LOCAL_STORE.CASHBACK_LEVEL, ""+store.state.accountInfo.rebateLevel);
    }
    return bool;
}

/**检查是否显示引导提现 */
export function checkShowWithdrawTip(): boolean {
    if (store.state.accountInfo.vipLevel == 0) {
        return false;
    }
    let isShow = localStorage.getItem(LOCAL_STORE.CHARGE_FIRST_TIP);
    if (isShow == "1") {    //已显示过
        return false;
    }
    showAlert(true, {
        msg: i18n.global.t('prop.44'),
        btnType: 2,
        isShowClose: false,
        confirmText: i18n.global.t('common.4'),
        confirmCall: () => {
            router.push('/withdraw');
        }
    });
    localStorage.setItem(LOCAL_STORE.CHARGE_FIRST_TIP, "1");
    return true;
}

/**检查金额是否达到了弹窗标准 */
function checkAmountLimit() {
    if (router.currentRoute.value.path != '/') {
        return ;
    }
    if (store.state.accountInfo.vipLevel == 0) {
        if (store.state.accountInfo.gold >= currentCashbackLimit) {
            store.state.isShowCashBackTip = true;
        }
    } else {
        if (store.state.accountInfo.withdrawNum == 1) {
            store.state.isShowCashBackTip = true;
        }
    }
    if (store.state.isShowCashBackTip == true) {
        return ;
    }
    let info: any = getSessionData(SESSION_STORE.ACCOUNT_INFO.key);
    if (info && info.chargeNum <= 3) {
        store.state.isShowCashBackProp = true;
    }
}